// extracted by mini-css-extract-plugin
module.exports = {"icon":"breadcrumbsItem_icon__iW2Hr","iconChevron":"breadcrumbsItem_iconChevron__2_-Hu"};